// extracted by mini-css-extract-plugin
export default {"profile_btn":"Profile_profile_btn__jaXfv","profile_avatar":"Profile_profile_avatar__e-il-","profile_icon":"Profile_profile_icon__v8b6q"};